export default "__VITE_ASSET__CU2k_$YL__"